import { c as _c } from "react/compiler-runtime";
import { createQueryFn, drawResultQueryKeys } from '../../../../lib/entry.js';
import { useSuspenseQuery } from '../../../../tanstack/entry.js';
import { getDrawResult } from '../../../actions/draw/entry.js';
const fetcher = createQueryFn(getDrawResult);
/**
 * Hook to get draw result or forecast.
 *
 * @param drawQueryOptions Props for draw results
 * @param drawQueryOptions.product - The product for which to get the draw result.
 * @param drawQueryOptions.drawNumber - The draw number to get the result for.
 * @param queryOptions Fetch query options
 * @returns Draw result or forecast
 */
export function useGetDrawResult(drawQueryOptions, queryOptions) {
  const $ = _c(9);
  let t0;
  if ($[0] !== drawQueryOptions.drawNumber || $[1] !== drawQueryOptions.product) {
    t0 = drawResultQueryKeys.result(drawQueryOptions.product, drawQueryOptions.drawNumber);
    $[0] = drawQueryOptions.drawNumber;
    $[1] = drawQueryOptions.product;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = queryOptions?.defaultValue;
  let t2;
  if ($[3] !== t1) {
    t2 = fetcher({
      defaultValue: t1
    });
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== queryOptions || $[6] !== t0 || $[7] !== t2) {
    t3 = {
      ...queryOptions,
      queryKey: t0,
      queryFn: t2
    };
    $[5] = queryOptions;
    $[6] = t0;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useSuspenseQuery(t3);
}